declare namespace $ {

	export class $mol_icon_volume_high extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=high.view.tree.d.ts.map